import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

export interface FooterLink {
  label: string;
  route?: string;
}

@Component({
  selector: 'app-footer',
  imports: [CommonModule, RouterLink],
  standalone: true,
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class FooterComponent {
  readonly services: FooterLink[] = [
    { label: 'Find a partner', route: '/find-a-partner' },
    { label: 'Become a partner', route: '/become-a-partner' },
  ];

  readonly coreModules: FooterLink[] = [
    { label: 'Sales', route: '/sales' },
    { label: 'CRM', route: '/crm' },
    { label: 'HR', route: '/hr' },
    { label: 'Procurement', route: '/procurement' },
    { label: 'Inventory', route: '/inventory' },
    { label: 'Manufacturing', route: '/manufacturing' },
    { label: 'Accounting', route: '/accounting' },
  ];

  readonly aboutLinks: FooterLink[] = [
    { label: 'Company', route: '/company' },
    { label: 'Jobs', route: '/jobs' },
    { label: 'Events', route: '/events' },
    { label: 'Customers', route: '/customers' },
    { label: 'Blogs', route: '/blogs' },
    { label: 'Security', route: '/security' },
    { label: 'Privacy policy', route: '/privacy-policy' },
  ];
  readonly socialLinks = [
    { name: 'facebook', icon: 'fab fa-facebook-f', url: 'https://www.facebook.com/' },
    { name: 'instagram', icon: 'fab fa-instagram', url: 'https://www.instagram.com/' },
    { name: 'linkedin', icon: 'fab fa-linkedin-in', url: 'https://www.linkedin.com/' },
    { name: 'github', icon: 'fab fa-github', url: 'https://github.com/' },
    { name: 'tiktok', icon: 'fab fa-tiktok', url: 'https://www.tiktok.com/' },
    { name: 'phone', icon: 'fas fa-phone', url: 'tel:+923000910043' },
    { name: 'twitter', icon: 'fab fa-twitter', url: 'https://twitter.com/' },
    { name: 'whatsapp', icon: 'fab fa-whatsapp', url: 'https://wa.me/923000910043' },
  ];

  constructor(private router: Router) {}

  scrollToTop() {
    this.router.navigate(['/']).then(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }
}
